export default __webpack_public_path__ + "static/media/ic_calendar-webinar-blue.f7b3ed62.svg";